import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Cube = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Cube' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,2 L22,7 L22,17 L12,22 L2,17 L2,7 L12,2 Z M2,7 L12,12 L22,7 M12,12 L12,21.9999998 L12,12 Z' />
  </StyledIcon>
);
